import { styled } from '@linaria/react';

import {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';

function FlexBasis() {
  return (
    <FlexDemo
      initialValues={{
        '--direction': 'row',
        flexBasis: 50,
        showAxisLabels: false,
      }}
      controls={[
        <DemoRadioControl
          key="--direction"
          id="--direction"
          label="flex-direction"
          options={['row', 'column']}
        />,
        <DemoSliderControl
          key="flexBasis"
          id="flexBasis"
          label="flex-basis"
          min={50}
          max={350}
          wrapperStyle={{
            color: 'hsl(50deg 100% 65%)',
          }}
          handleColor="hsl(50deg 100% 60%)"
          handleFocusColor="hsl(50deg 100% 60%)"
        />,
      ]}
    >
      {({ flexBasis, ...state }) => (
        <Wrapper>
          <Output state={state} height={300}>
            <Item
              primary
              layout={false}
              style={{ flexBasis: flexBasis }}
              wrapperStyle={{
                padding: 0,
              }}
            />
            <Item
              layout={false}
              style={{ flexBasis: 50, minWidth: 0, minHeight: 0 }}
              wrapperStyle={{
                padding: 0,
              }}
            />
            <Item
              layout={false}
              style={{ flexBasis: 50, minWidth: 0, minHeight: 0 }}
              wrapperStyle={{
                padding: 0,
              }}
            />
            <Item
              layout={false}
              style={{ flexBasis: 50, minWidth: 0, minHeight: 0 }}
              wrapperStyle={{
                padding: 0,
              }}
            />
          </Output>
        </Wrapper>
      )}
    </FlexDemo>
  );
}

const Wrapper = styled.div`
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default FlexBasis;
